import $ from 'jquery';
window.$ = window.jQuery = $;
$(document).on("click",".addressfilter", function()
{

		let oc_id = $(this).attr('data-orig-cat');
		let cat_id = $(this).attr('data-category-id');
		let con = $(this).attr("data-country-id");
		let st = $(this).attr("data-state_id");
		let city_st = $(this).attr("data-cstate-id");
		let state_con = $(this).attr("data-scontry-id");
		let city_con = $(this).attr("data-ccontry_id");
		let checkBoxArray = new Array();
		let country = new Array();
		let categorylist = [];
		let countrylist = [];
		let city = new Array();
		let state = new Array();
		let citylist = [];
		let statelist = [];
		let baseurl = "{{url('/')}}";
		console.log(baseurl);
		$(':checkbox:checked').each(function(i) {
			let categories = $(this).attr("data-category-id")
			if (categories != null) {
				checkBoxArray.push(categories);
			}
		});
		if (checkBoxArray.length == 0) {
			categorylist += oc_id;

		} else {
			while (checkBoxArray.length != 0) {
				if (checkBoxArray.length == 1) {
					categorylist += checkBoxArray.pop();
				} else {
					categorylist += (checkBoxArray.pop() + ",");
				}
			}
			categorylist += ',' + oc_id;

		}
		$(':checkbox:checked').each(function(i) {
			let contries = $(this).attr("data-scontry-id");
			console.log("hdshjbhjb");
			console.log(contries);
			if (contries != null) {
				country.push(contries);
			}
		});
		if (country.length == 0) {} else {
			while (country.length != 0) {
				if (country.length == 1) {
					countrylist += country.pop();
				} else {
					countrylist += (country.pop() + ",");
				}
			}
		}
		if (countrylist.length == 0) {
			countrylist = $('#countrylistoptions').find(':selected').attr("data-country-id");
			console.log('s : ',countrylist);
		}

		$(':checkbox:checked').each(function(i) {
			let states = $(this).attr("data-state_id");
			console.log('st' + states);
			if (states != null) {
				state.push(states);
			}
		});
		if (state.length == 0) 
		{
			statelist = $('#addressfilter').find(':selected').attr("data-state_id");
			console.log('states : ',statelist);
		} 
		else 
		{
			while (state.length != 0) 
			{
				if (state.length == 1) {
					statelist += state.pop();
				} else {
					statelist += (state.pop() + ",");
				}
			}
		}
		$(':checkbox:checked').each(function(i) {
			let cities = $(this).attr("data-city_id");
			if (cities != null) {
				city.push(cities);
			}
		});
		if (city.length == 0) {} else {
			while (city.length != 0) {
				if (city.length == 1) {
					citylist += city.pop();
				} else {
					citylist += (city.pop() + ",");
				}
			}
		}
		console.log('state : ' + statelist);
		console.log('country : ' + countrylist);
		console.log('category : ' + categorylist);
		console.log('city : ' + citylist);
		console.log($('meta[name="csrf-token"]').attr('content'));
		$(document).ajaxSend(function() 
		{
			$("#overlay").fadeIn(300);　
		});
		$.ajax(
		{
			
			headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
			url: '/filterdata/' + categorylist + '/' + oc_id,
			type: 'POST',
			data: {
				"_token": $("input[name='_token']").val(),
				"oc_id": oc_id,
				"categorylist": categorylist,
				"countrylist": countrylist,
				"statelist": statelist,
				"citylist": citylist
			},
			dataType: 'json',
			success: function(response) {
				
				$('#vlist').html(response.markup);
				$('param[name="next-page-vendors"]').val(response.next_page_url);

			},
			error: function(jqXHR, textStatus, errorThrown, response) {

				alert('Internal error: ' + errorThrown);

			},
			complete: function(argument) {
				if ($('param[name="next-page-vendors"]').val() == '') {
					//$('.load-more').removeClass('dis-none');
					$('.load-more').css("display", "none");
					//$("#radio").css("display", "block");

				} else {
					let lbtn = '<div class="row"><dev class="col-md-2 offset-md-5"><button type="button" class="sign  load-more" style="display:block">Load More</button></dev></div>';
					$('.rm').html(lbtn);
					$('.load-more').css("display", "block");

				}
			}
		}).done(function() {
			setTimeout(function() {
				$("#overlay").fadeOut(300);
			}, 500);
		});
	});

//category link

$(document).ready(function() 
{
	$(".categorylink").change(function(e) 
	{
		let url = window.location.origin + '/category/' + $('.categorylink option:selected').data('id');
		$(this).val('');
	    console.log(url);
	   window.location.href = url;
	});
});
function categorylink() 
{
	let url = window.location.origin + '/category/' + document.getElementById("invlistoptions").value;
	console.log(url);
}

//showcasecategory link

$(document).ready(function() 
{
	$(".inventionlink").change(function(e) 
	{
		let url = window.location.origin + '/showcase/category/' + $(".inventionlink option[value='" + $('.inventionlink').val() + "']").attr('data-id');
		$(this).val('');
	   // window.open(url);
	   window.location.href = url;
	});
});

//country filter
$(document).ready(function() 
{
	$(".countryfilterdata").change(function(e) 
	{
		let oc_id = $(this).attr('data-orig-cat');
		let cat_id = $(this).attr('data-category-id');
		let con = $(this).find(':selected').attr("data-country-id")
		let st = $(this).find(':selected').attr("data-state_id");
		let city_st = $(this).find(':selected').attr("data-cstate-id");
		let state_con = $(this).attr("data-scontry-id");
		let city_con = $(this).attr("data-ccontry_id");
		let checkBoxArray = new Array();
		let country = new Array();
		let categorylist = [];
		let countrylist = [];
		let city = new Array();
		let state = new Array();
		let citylist = [];
		let statelist = [];
		$(':checkbox:checked').each(function(i) {
			let categories = $(this).attr("data-category-id")
			if (categories != null) {
				checkBoxArray.push(categories);
			}
		});
		if (checkBoxArray.length == 0) {
			categorylist += oc_id;

		} else {
			while (checkBoxArray.length != 0) {
				if (checkBoxArray.length == 1) {
					categorylist += checkBoxArray.pop();
				} else {
					categorylist += (checkBoxArray.pop() + ",");
				}
			}
			categorylist += ',' + oc_id;

		}
		countrylist += con;
		 
		filterdata(categorylist,countrylist,statelist,citylist,oc_id);
		$.ajax(
		{
			headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
			url: '/state-city/' + categorylist +'/' + oc_id +'/' + con,
			type: 'POST',
			data: {
				"_token": $("input[name='_token']").val(),
				"oc_id": oc_id,
				"categorylist": categorylist,
				"countrylist": countrylist,
				"statelist": statelist,
				"citylist": citylist
			},
			dataType: 'json',
			success: function(response)
			{
				  $('#countrystatedata').html(response.html);
			}
		});
		if(countrylist == '')
		{
			document.getElementById("countrystatedata").style.display = "none";
		}
		else
		{
			document.getElementById("countrystatedata").style.display = "block";
		 
		} 
	});
});

//common function for country filter
function filterdata(categorylist,countrylist,statelist,citylist,oc_id)
{
	$(document).ajaxSend(function() 
	{
		$("#overlay").fadeIn(300);　
	});
	$.ajax(
	{
		
		headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
		url: '/filterdata/' + categorylist + '/' + oc_id,
		type: 'POST',
		data: {
			"_token": $("input[name='_token']").val(),
			"oc_id": oc_id,
			"categorylist": categorylist,
			"countrylist": countrylist,
			"statelist": statelist,
			"citylist": citylist
		},
		dataType: 'json',
		success: function(response) {
			
			$('#vlist').html(response.markup);
			$('param[name="next-page-vendors"]').val(response.next_page_url);

		},
		error: function(jqXHR, textStatus, errorThrown, response) {

			alert('Internal error: ' + errorThrown);

		},
		complete: function(argument) {
			if ($('param[name="next-page-vendors"]').val() == '') {
				//$('.load-more').removeClass('dis-none');
				$('.load-more').css("display", "none");
				//$("#radio").css("display", "block");

			} else {
				let lbtn = '<div class="row"><dev class="col-md-2 offset-md-5"><button type="button" class="sign  load-more" style="display:block">Load More</button></dev></div>';
				$('.rm').html(lbtn);
				$('.load-more').css("display", "block");

			}
		}
	}).done(function() {
		setTimeout(function() {
			$("#overlay").fadeOut(300);
		}, 500);
	});
}


//Search Vendor
/*$(document).ready(function()
{
	document.onkeyup = enter;

	function enter(e)
	{
		if (e.which == 13)
		{
			let id = $("#search").attr("data-category-id");
			let search =$("#search").val();
			console.log(id,search,"haghgh");
			$(document).ajaxSend(function() 
			{
				   $("#overlay").fadeIn(300);　
			});  
			$.ajax(
			{
				headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
				url: '/search-vendor/' + id,
				type: 'POST',
				data: {"_token": $("input[name='_token']").val(),"search": search},
				dataType: 'json',
				success: function(response)
				{
				 	$('#vlist').html(response.html);
					$(".load-more").css('display','none');
					 
				}
			}).done(function() 
			{
				setTimeout(function(){
				$("#overlay").fadeOut(300);
			},500);
			});  
		} 
	}
});	*/	
$(document).ready(function() 
{
	$('.catsearch').on('click', function() 
	{
		let id = $("#search").attr("data-category-id");
		let search =$("#search").val();
		console.log(id,search,"haghgh");
		$(document).ajaxSend(function() 
		{
			   $("#overlay").fadeIn(300);　
		});  
		$.ajax(
		{
			headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
			url: '/search-vendor/' + id,
			type: 'POST',
			data: {"_token": $("input[name='_token']").val(),"search": search},
			dataType: 'json',
			success: function(response)
			{
			 	$('#vlist').html(response.html);
				$(".load-more").css('display','none');
				 
			}
		}).done(function() 
		{
			setTimeout(function(){
			$("#overlay").fadeOut(300);
		},500);
		});       
	});
});
$(document).on("click",".shareUrlLink", function()
{
	$.ajax(
	{
		url: '/vendor/share/url',
		type: 'get',
		success: function(response)
		{
			alert("link share successfully");
		},
		  error: function (jqXHR, textStatus, errorThrown,response) 
		{
			 alert('Internal error: ' + errorThrown);
           },
	});
});